export enum AdminLevel {
  ROOT = 1,
  BASIC = 2,
  SUPER = 3,
  INITIAL = 4,
}

export interface createAdmin {
  firstName: string;
  lastName: string;
  dateOfBirth: Date;
  email: string;
  password: string;
  adminType: AdminLevel;
}
